<script setup>
import InfoSectionCard from '@/components/cards/InfoSectionCard.vue';

defineProps({
  data: {
    type: Object,
    default: () => ({}),
  },
});
</script>
<template>
  <section
    :id="data.id"
    class="section"
    :class="[
      data?.background_color ? `bg-${data?.background_color}` : '',
      data?.spacing?.top
        ? `section--top-${data.spacing.top}`
        : 'section--top-xl',
      data?.spacing?.bottom
        ? `section--bottom-${data.spacing.bottom}`
        : 'section--bottom-xl',
    ]"
    data-aos="fade-up"
    data-aos-easing="ease-out-cubic"
  >
    <div class="container">
      <div
        class="info_sections"
        :class="[data?.background_color === 'black' ? 'white' : 'black']"
      >
        <h2
          v-if="data.title"
          class="mb-0 info_sections__title h2 text-center"
          data-aos="fade-up"
          data-aos-easing="ease-out-cubic"
          v-html="data.title"
        ></h2>
        <div class="info_sections__items">
          <template v-for="(item, index) in data.items" :key="index">
            <InfoSectionCard
              :title="item?.title"
              :image="item?.image"
              :description="item?.description"
              :theme="data?.background_color"
              data-aos="fade-up"
              :data-aos-delay="index >= 1 ? 100 + 100 * index : 100"
            />
          </template>
        </div>
      </div>
    </div>
  </section>
</template>

<style scoped lang="scss">
@use 'sass:math';
.info_sections {
  display: flex;
  flex-direction: column;
  gap: 80px;
  @include media-breakpoint-up(sm) {
    gap: 120px;
  }
  @include media-breakpoint-up(xl) {
    @include responsive-spacing(gap, 120);
  }
  &__title {
    margin: 0;
  }
  &__items {
    display: flex;
    flex-direction: column;
    gap: 80px;
    @include media-breakpoint-up(sm) {
      gap: 120px;
    }
    @include media-breakpoint-up(xl) {
      @include responsive-spacing(gap, 120);
    }
  }
}
</style>
